import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { formatLengthUnit } from '../../utils/data-formatter';
import DimensionRule from '../dimension-rule';
import { clusterTerminationData, configurationModuleType, edgeClusterHead, front_base_url } from '../../constants';
import I10n from '../../features/i10n';
import DropdownMenu from '../dropdown_menu';
import Device from '../../models/Device';

const BlockWrapper = styled.div`
  display: inline-block;
  ${props => !props.isLast && `margin-right: 20px;`}
`;

const BlockWithDimension = styled.div`
  position: relative;
  display : inline-block;
  flex-direction: column;
`;

const BlockModulesWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const ModuleWithBusWrapper = styled.div`
  display: inline-block;
`;

const InlineRow = styled.div`
  display: inline-block;
  ${props => props.paddingLeft ? `padding-left: ${props.paddingLeft}px;` : ''}
`;

const ModuleAndHintWrapper = styled.div`
  position: relative;
`;

const TooltipWrapper = styled.div`
  position: absolute;
  z-index: 3;
  top: -10px;
  left: 0; right: 0;
`;

const TooltipText = styled.span`
  position: absolute;
  color: white;
  background-color: #323232;
  top: -20px;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 2px;
`;

const TooltipTriangle = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 5px 0 5px;
  border-color: #323232 transparent transparent transparent;
  margin-left: calc(50% - 5px);
`;

const ModuleAndWiringWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const GraphicalViewItem = styled.div`
  position: relative;
  height: 100%;
`;

const ModuleItemWrapper = styled(GraphicalViewItem)`
  display: inline-block;
  height: 160px;
  vertical-align: bottom;
`;

const ModuleItem = styled.div`
  display: inline-block;
  height: 160px;
  z-index: 1;
  position: relative;
  vertical-align: bottom;
`;

const DeviceImageWrapper = styled.label`
  display: block;
  position: relative;
  cursor: pointer;

  :after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
    box-sizing: border-box;


    ${props => props.valid ? `
      border: 2px solid transparent;
      border-radius: 2px;
      ${props.selected && `
        background-color: rgba(66, 180, 230, 0.2);
      `}
    ` : `
      background: repeating-linear-gradient(
        -55deg,
        rgba(230, 66, 66, 0.2),
        rgba(230, 66, 66, 0.2) 10px,
        rgba(230, 66, 66, 0.7) 10px,
        rgba(230, 66, 66, 0.7) 14px
      );
    `}

    ${props => props.selected && `
      border-color: #42b4e6;
    `}
  }

  :hover {
    :after {
      border-color: #42b4e6;
      ${props => props.valid ? `
        background-color: rgba(66, 180, 230, 0.2);
      ` : `
        background: repeating-linear-gradient(
          -55deg,
          rgba(66, 180, 230, 0.2),
          rgba(66, 180, 230, 0.2) 10px,
          rgba(230, 66, 66, 0.7) 10px,
          rgba(230, 66, 66, 0.7) 14px
        );
      `}
    }
  }

`;

const DeviceImage = styled.img`
  display: block;
  height: ${props => `${props.height}px`};
  width: ${props => `${props.width}px`};
  font-size: 8px;
  writing-mode: vertical-lr;
  text-orientation: upright;
  text-align: center;
`;
const SlottedDeviceImage = styled(DeviceImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const ModuleActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  min-width: 200px;
`;

const EdgeWireStart = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: 100px;
  margin-left: 50%;
  bottom: -15px;
  border-left: 5px solid #42B4E6;
  border-left: 5px solid var(--se-secondary, #42B4E6);
  border-bottom: 5px solid #42B4E6;
  border-bottom: 5px solid var(--se-secondary, #42B4E6);
`;

const EdgeWireMiddleWrapper = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  bottom: -15px;
`;

const EdgeWireLineH = styled.div`
  width: ${props => props.width}px;
  height: 15px;
  border-bottom: 5px solid #42B4E6;
  border-bottom: 5px solid var(--se-secondary, #42B4E6);
`;

const EdgeWireEnd = styled.div`
  position: absolute;
  width: 50%;
  height: 100px;
  border-right: 5px solid #42B4E6;
  border-right: 5px solid var(--se-secondary, #42B4E6);
  border-bottom: 5px solid #42B4E6;
  border-bottom: 5px solid var(--se-secondary, #42B4E6);
  bottom: -15px;
`;

const ClusterModuleDisplayer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
  right: 0px;
  top: -20px;
  border: 1px solid #42B4E6;
  border: 1px solid var(--se-secondary,#42B4E6);
  color: #42B4E6;
  color: var(--se-secondary,#42B4E6);
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

const UnderLineButtonBus = styled.div`
position: relative;
display: inline-block;
vertical-align: bottom;
`;

class EdgeCluster extends React.Component {

  static propTypes = {
    block: PropTypes.object,
    blockIdx: PropTypes.number,
    blocks: PropTypes.array,
    renderDimensions: PropTypes.bool,
    maxModuleHeight: PropTypes.number,
    headModule: PropTypes.object,
    typeModuleSelected: PropTypes.string,
    slotModuleSelected: PropTypes.number,
    updateSelectedModule: PropTypes.func,
    renderModuleActions: PropTypes.func,
    wrapperElement: PropTypes.object,
    isLastCluster: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = {
      hideClusterModules: false,
    };
  }

  get canTooltipAppears() {
    try {
      return localStorage.getItem('tooltip-head-occurs') == null;
    } catch (error) {
      return true;
    }
  }

  computeModuleHeight = (realHeight, maxModuleHeight) => {
    const heightRatio = Math.ceil(100 * realHeight / maxModuleHeight) / 100;
    return 160 * (heightRatio ? heightRatio : 1);
  }

  computeModuleWidth = (realWidth, realHeight, newHeight) => {
    const aspectRatio = realWidth / realHeight;
    return newHeight * (aspectRatio ? aspectRatio.toFixed(2) : 1);
  }

  renderEdgeWiring = (idxInBlock, blockIdx, nbBlocks, imageWidth) => {
    const isLastBlock = ((blockIdx + 1) === nbBlocks);
    const isFirstBlock = blockIdx === 0;

    return (
      <>
        {idxInBlock === 0 && nbBlocks > 1 &&
          <>
            {isLastBlock && <EdgeWireEnd>
            </EdgeWireEnd>}
            {!isLastBlock && <InlineRow>
              <EdgeWireStart width={imageWidth / 2.0 + 20}>
              </EdgeWireStart>
            </InlineRow>}
          </>
        }
        {!isLastBlock && (idxInBlock > 0 || !isFirstBlock)  &&
          <EdgeWireMiddleWrapper width={imageWidth + 20}>
            <EdgeWireLineH width={imageWidth + 20}></EdgeWireLineH>
          </EdgeWireMiddleWrapper>
        }
      </>
    );
  }


  renderModule = (device, maxModuleHeight, idxInBlock, blockIdx, nbBlocks) => {
    const slot = device.slot;
    const moduleType = device.moduleType;
    const realHeight = device.height ? device.height : 0;
    const realWidth = device.width ? device.width : 0;
    const imageHeight = this.computeModuleHeight(realHeight, maxModuleHeight);
    const imageWidth = this.computeModuleWidth(realWidth, realHeight, imageHeight);
    const slottedDevicesImages = device.getSlottedDevicesFrontImageLinks();

    const ModuleRender = (
      <>
        {(!this.state.hideClusterModules || edgeClusterHead === device.productType || this.props.renderDimensions) &&
        <ModuleAndWiringWrapper>
            <ModuleItem>
              <DeviceImageWrapper
                htmlFor={`${device.id}_${slot}`} valid={device.validator.valid}
                selected={moduleType === this.props.typeModuleSelected && slot === this.props.slotModuleSelected}
                onClick={() => {
                  this.props.updateSelectedModule(slot, moduleType);
                  try {
                    localStorage.setItem('tooltip-head-occurs', '1');
                  } catch (error) {
                  }
                }}

                onContextMenu={() => {
                  this.props.updateSelectedModule(slot, moduleType);
                  try {
                    localStorage.setItem('tooltip-head-occurs', '1');
                  } catch (error) {
                  }
                }
                }
              >
                <DeviceImage
                  src={`${front_base_url}/images/small-devices-images/${device.id}_h320px.png`}
                  alt={``}
                  height={imageHeight}
                  width={imageWidth}
                >
                </DeviceImage>
                {!(configurationModuleType.head_module === moduleType) && slottedDevicesImages.map((imgObj, i) => {
                  return (
                    <SlottedDeviceImage
                      key={i}
                      src={`${front_base_url}/images/small-devices-images/${imgObj.src}_h320px.png`}
                      height={imageHeight}
                      width={imageWidth}
                    >
                    </SlottedDeviceImage>
                  );
                })}
              </DeviceImageWrapper>
            </ModuleItem>
            {this.renderEdgeWiring(idxInBlock, blockIdx, nbBlocks, imageWidth)}
        </ModuleAndWiringWrapper>}
      </>
    );

    return (
      <ModuleItemWrapper key={`${device.id}_${slot}`}>
        {<DropdownMenu
          data-clickable
          fixedTop={20}
          openOnRightClick={true}
          toggleElement={<>{ModuleRender}</>}
          boundingElement={this.props.wrapperElement}
          containerElement=
          {
            <ModuleActionsWrapper>
              {this.props.renderModuleActions(false)}
            </ModuleActionsWrapper>
          }>
        </DropdownMenu>}
      </ModuleItemWrapper>
    );
  };

  renderButtonBus = () => {
    return (
      <EdgeWireMiddleWrapper width={70}>
        <EdgeWireLineH width={70}></EdgeWireLineH>
      </EdgeWireMiddleWrapper>
    );
  };


  renderHeadModule = (maxModuleHeight, idxInBlock, blockIdx, nbBlocks) => {
    const device = this.props.headModule;

    return (
      <ModuleAndHintWrapper>
        {this.renderModule(device, maxModuleHeight, idxInBlock, blockIdx, nbBlocks)}
        {this.canTooltipAppears && <TooltipWrapper>
          <TooltipText>
            {I10n.get('screen.config_editor.preview.tooltip')}
          </TooltipText>
          <TooltipTriangle></TooltipTriangle>
        </TooltipWrapper>}
      </ModuleAndHintWrapper>
    );
  }

  renderTermination = (nbModulesInBlock) => {
    const device = new Device(clusterTerminationData);
    const realHeight = device.height ? device.height : 0;
    const realWidth = device.width ? device.width : 0;
    const imageHeight = this.computeModuleHeight(realHeight, this.props.maxModuleHeight);
    const imageWidth = this.computeModuleWidth(realWidth, realHeight, imageHeight);


    return (
      <ModuleWithBusWrapper>
        <InlineRow paddingLeft={0}>
          <ModuleAndWiringWrapper>
            <ModuleItem>
                <DeviceImage
                  src={`${front_base_url}/images/small-devices-images/${device.id}_h320px.png`}
                  alt={``}
                  height={imageHeight}
                  width={imageWidth}
                >
                </DeviceImage>
            </ModuleItem>
            {this.renderEdgeWiring(nbModulesInBlock, this.props.blockIdx, this.props.blocks.length, imageWidth)}
          </ModuleAndWiringWrapper>
        </InlineRow>
      </ModuleWithBusWrapper>
    );
  }

  render = () => {
    const lastModuleSlot = Math.max(...this.props.block.modules.map(mod => mod.slot));
    const activeModulesCount = this.props.block.countableModules().length;
    const isClusterFull = activeModulesCount >= this.props.rangeInfo.maxBlockIOModules;
    const lastModule = this.props.block.modules[this.props.block.modules.length - 1];

    return (
      <BlockWrapper key={this.props.blockIdx} isLast={(this.props.blockIdx + 1) === this.props.blocks.length}>
        <BlockWithDimension>
          {this.props.renderDimensions && this.props.block.hasWidth() && (
            <DimensionRule
              text={formatLengthUnit(this.props.block.width())}
              orientation={'horizontal'}
            ></DimensionRule>
          )}
          <BlockModulesWrapper>
            {!this.props.renderDimensions && this.props.block.modules.length > 1 && <ClusterModuleDisplayer onClick={() => { this.setState({hideClusterModules: !this.state.hideClusterModules}); }}>{this.state.hideClusterModules ? '+' : '-'}</ClusterModuleDisplayer>}
            {this.props.block.modules.map((module, idx) => {
              return (
                <ModuleWithBusWrapper key={idx}>
                  <InlineRow paddingLeft={0}>
                    {module.moduleType === configurationModuleType.head_module ?
                      this.renderHeadModule(this.props.maxModuleHeight, idx, this.props.blockIdx, this.props.blocks.length)
                      :
                      this.renderModule(module, this.props.maxModuleHeight, idx, this.props.blockIdx, this.props.blocks.length)
                    }
                  </InlineRow>
                </ModuleWithBusWrapper>
              );
            })}

            <UnderLineButtonBus>
              {this.props.isLastCluster
                ? this.props.renderAddIOButton(this.props.maxModuleHeight, this.props.isTotalLimitReached, this.props.isTotalLimitReached)
                : <>
                  {this.props.renderClusterAddIOButton(lastModuleSlot, lastModule, this.props.maxModuleHeight, isClusterFull || this.props.isTotalLimitReached, this.props.isTotalLimitReached)}
                  {this.renderButtonBus()}
                </>
              }
            </UnderLineButtonBus>

            {this.renderTermination(this.props.block.modules.length)}

          </BlockModulesWrapper>
        </BlockWithDimension>
      </BlockWrapper>
    );
  }
}

export default EdgeCluster;
